<div class="wetter_content_container">
  <mat-horizontal-stepper labelPosition="bottom" [linear]="false" #stepper="matHorizontalStepper">
    <ng-template matStepperIcon="edit">
      <mat-icon>my_location</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="done">
      <mat-icon>my_location</mat-icon>
    </ng-template>

    <ng-container *ngFor="let i of let region of regionalWetterbericht?.regionsListe">
      <mat-step>
        <ng-template class="mat-step-header" matTooltip="{{region?.title}}"
                     matStepLabel>{{ region?.title }}
        </ng-template>
        <div class="bericht-text-container">
          <h2>{{ region?.title }}</h2>
          <h3>Headline</h3>
          {{ region?.headline }}
        </div>
        <div class="bericht-text-container">
          <h3>Heute</h3>
          {{ region?.wx_text_today }}
        </div>
        <div class="bericht-text-container">
          <h3>Morgen</h3>
          {{ region?.wx_text_tomorrow }}
        </div>
        <div class="bericht-text-container">
          <h3>Übermorgen</h3>
          {{ region?.wx_text_the_day_after_tomorrow }}
        </div>
      </mat-step>
    </ng-container>
  </mat-horizontal-stepper>
</div>
